import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { setAnalyticsHttpClient } from 'igentify-node-shared/dist/services/analytics';
import { HttpClientFactory } from '@/shared/services/HttpClientFactory';
import { configs } from '@/shared/configs';
import { authService } from '@/shared/services';
import store from '@/store';

function setHeaders(config: AxiosRequestConfig) {
  if (!config.headers) {
    config.headers = {};
  }

  config.headers.Authorization = `Bearer ${authService.getAuthToken()}`;

  return config;
}

function setIsLoading(isLoading: boolean) {
  store.dispatch('httpModule/setIsLoading', isLoading);
}

function setResponse(res: AxiosResponse) {
  setIsLoading(false);

  return res;
}

function setError(err: any) {
  setIsLoading(false);

  return Promise.reject(err);
}

const accessInstance = HttpClientFactory.build(
  { baseURL: configs.ACCESS_BASE_API },
);
const accessInstanceSilent = HttpClientFactory.build(
  { baseURL: configs.ACCESS_BASE_API },
  { silentErrorHandling: true },
);
const assetsInstance = HttpClientFactory.build({ baseURL: configs.ASSETS_BASE_API });
const rainbowInstance = HttpClientFactory.build({ baseURL: configs.RAINBOW_BASE_API });

// accessInstance.interceptors.request.use(setHeadersWithLoader);
accessInstance.interceptors.response.use(setResponse, setError);

accessInstanceSilent.interceptors.request.use(setHeaders);

setAnalyticsHttpClient(HttpClientFactory.baseClientSilent);

export const httpClient = {
  // config.headers["Authorization"] = `Bearer ${authToken}`;
  get client() {
    return HttpClientFactory.baseClient;
  },
  get baseClientSilent() {
    return HttpClientFactory.baseClientSilent;
  },
  get access() {
    return accessInstance;
  },
  get accessSilent() {
    return accessInstanceSilent;
  },
  get rainbow() {
    return rainbowInstance;
  },
  get assets() {
    return assetsInstance;
  },
};
